import { useMemo } from 'react'
import { FilterDescriptor } from '@progress/kendo-data-query'
import { useAppSelector } from 'store'
import stringComparator from 'utils/stringComparator'

import { SelectFilter } from '../SelectFilter'

export const AssigneeFilter = ({
  filter,
  onFilterChange,
}: {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}): JSX.Element => {
  const users = useAppSelector((state) => state.identity.administrationUsers) ?? []

  const sortedUsers = useMemo(
    () => [...users].sort((a, b) => stringComparator(a.name, b.name)),
    [users]
  )
  const data = sortedUsers.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return (
    <SelectFilter
      placeholder='Assignee'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
      style={{ width: 200 }}
    />
  )
}
